import { render, staticRenderFns } from "./LayerPropertiesForm.vue?vue&type=template&id=762ad476"
import script from "./LayerPropertiesForm.vue?vue&type=script&lang=js"
export * from "./LayerPropertiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports